import script from "./RewardsListQuery.vue?vue&type=script&lang=js"
export * from "./RewardsListQuery.vue?vue&type=script&lang=js"

const __exports__ = script;

export default __exports__